import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import deepmerge from "deepmerge";
import sift from "sift";
import config from "../../config";
import { generateBuilderSlug, lowercaseAndParseSpaces } from "../utils";
var PROJECT_SLUG = config.get("api.project"),
    NB_SLUG = config.get("api.neighbourhood");
export var initNeighbourhoods = function initNeighbourhoods(a, b) {
  var c = b.parseUrl,
      d = b.parseSlug,
      e = a.data || {},
      f = e.assetpath,
      g = e.landsearch,
      h = e.apartmentSearch,
      i = e.packageSearch,
      j = _objectWithoutProperties(e, ["assetpath", "landsearch", "apartmentSearch", "packageSearch"]),
      k = [],
      l = [],
      m = function m(b) {
    l.push(b), b.slug = b.slug.toLowerCase();
    var e = b.estate_name,
        f = b.slug,
        g = b.precincts; // if we are looking for an specific neighbourhood name
    // loop through all the project neighbourhoods (third level)

    return g.find(function (g) {
      g.landforsale || (g.landforsale = g["land-for-sale"], delete g["land-for-sale"]), g.slug = g.slug.toLowerCase();
      var h = g.name,
          i = g.slug,
          j = g.landforsale;

      if (g.masterplan_flyer = g.masterplan_flyer ? c(g.masterplan_flyer) : b.masterplan_flyer, g.duediligence_flyer = g.duediligence_flyer ? c(g.duediligence_flyer) : b.duediligence_flyer, g.design_guidelines_flyer = g.design_guidelines_flyer ? c(g.design_guidelines_flyer) : b.design_guidelines_flyer, g.image = _objectSpread({}, g.image, {
        url: c(g.image.url)
      }), g.project_name = e, g.project_slug = f, g.packages && (g.packages = g.packages.map(function (a) {
        // pkg.release_name = projectName;
        return a.slug = d(a, {
          projectSlug: f,
          neighbourhoodSlug: i
        }), a.similar && (a.similar = a.similar.filter(function (a) {
          return a;
        }), a.similar = a.similar.map(function (b) {
          return "object" != typeof b && (b = {
            slug: b,
            propertyType: a.propertyType
          }), b.slug && (b.slug = d(b, {
            projectSlug: f,
            neighbourhoodSlug: i
          })), b;
        })), a.propertyType = "ap" === a.propertyType ? "apartment" : "th" === a.propertyType ? "townhome" : "house", a.builders_name && (a.builders_slug = generateBuilderSlug(a.builders_name)), a.price = parseInt(a.price) || 0, a.lot_frontage = parseInt(a.lot_frontage) || 0, a.builder_logo && (a.builder_logo = c(a.builder_logo)), a.lot_flyer && (a.lot_flyer = c(a.lot_flyer)), a.flyer && (a.flyer = c(a.flyer)), a.image = a.image ? c(a.image.url) : null, a.image_single && (a.image_single = c(a.image_single)), a.plan_image && (a.plan_image = c("/packages/single".concat(a.plan_image))), a.floor_image && (a.floor_image = c(a.floor_image)), a.floorplan_image && (a.floorplan_image = c(a.floorplan_image)), a.floorplan_ground_image && (a.floorplan_ground_image = c(a.floorplan_ground_image)), a.floorplan_first_image && (a.floorplan_first_image = c(a.floorplan_first_image)), a.gallery && (a.gallery = a.gallery.replace(/\s/g, "").split(","), a.gallery = a.gallery.map(function (a) {
          return c(a);
        })), a.neighbourhood_id = a.precinct_id, a.neighbourhood_name = h, a.neighbourhood_slug = i, delete a.precinct_id, delete a.precinct_name, a.project_name = e, a.project_slug = f, a;
      })), g.landforsale && (g.landforsale = g.landforsale.map(function (a) {
        return a.slug = a.slug.toLowerCase(), a.lots && (a.lots = a.lots.map(function (b) {
          return b.slug || (b.slug = lowercaseAndParseSpaces(b.name)), b.packages && (b.packages = b.packages.map(function (c) {
            c.propertyType = "hal";
            var e = d(c, {
              projectSlug: f,
              neighbourhoodSlug: i
            }),
                h = g.packages.find(function (a) {
              return a.slug === e;
            });
            return h && (h.release_slug = a.slug, h.release_name = a.name, b.attributes && b.attributes.length && (h.attributes = [].concat(_toConsumableArray(b.attributes), _toConsumableArray(h.attributes)), h.attributes = h.attributes.filter(function (a, b) {
              return h.attributes.indexOf(a) === b;
            }))), {
              slug: e
            };
          })), _objectSpread({}, b, {
            neighbourhood_slug: i,
            release_slug: a.slug,
            release_name: a.name,
            propertyType: "land",
            project_name: e,
            project_slug: f,
            image: _objectSpread({}, b.image, {
              url: c(b.image.url)
            }),
            flyer: c(b.flyer)
          });
        })), _objectSpread({}, a, {
          image: _objectSpread({}, a.image, {
            url: c(a.image.url)
          })
        });
      })), g.townhomes && (g.townhomes = g.townhomes.map(function (a) {
        a.slug = a.slug.toLowerCase(), a.available_townhomes = !1, a.slug = a.slug.split("townhomes/")[1], a.neighbourhood_name = h, a.neighbourhood_slug = i, a.lots = a.lots.map(function (b) {
          return b.coords = b.coords || b.streetscape_coords, a.available_townhomes || (a.available_townhomes = 2 !== b.status), b.packages = b.packages.map(function (b) {
            if (b && b.id) {
              var c = g.packages.find(function (a) {
                var c = a.id;
                return c === b.id;
              });
              c && (c.release_slug = a.slug, c.release_name = a.name);
            }

            return b;
          }), b;
        });
        var b = a.image || {},
            d = a.image_streetscape || {};
        return _objectSpread({}, a, {
          neighbourhood_slug: i,
          release_slug: a.slug,
          release_name: a.name,
          propertyType: "townhome",
          image_streetscape: _objectSpread({}, d, {
            url: c(d.url)
          }),
          image: _objectSpread({}, b, {
            url: c(b.url)
          })
        });
      })), g.apartments && (g.apartments = g.apartments.map(function (a) {
        return a.slug = a.slug.toLowerCase(), a.available_aparments = !1, a.slug = a.slug.split(" ").join("-"), a.image && a.image.url && (a.image.url = c(a.image.url)), a.levels = a.levels.map(function (b) {
          return b.apartments = b.apartments.map(function (c) {
            if (c && c.package_id) {
              var d = g.packages.find(function (a) {
                var b = a.id;
                return b === c.package_id;
              });
              a.available_aparments || (a.available_aparments = 2 !== c.status), d && (d.level = b.name, d.release_name = a.name, d.release_slug = a.slug);
            }

            return c;
          }), b.apartments = b.apartments.filter(function (a) {
            return a;
          }), b.image && b.image.url && (b.image.url = c(b.image.url)), b;
        }), a;
      })), NB_SLUG) {
        return !!(i === NB_SLUG) && (a.current = deepmerge(a.current, g), j && k.push(g), !0);
      }

      return a.current = deepmerge(a.current, g), j && k.push(g), !1;
    });
  };

  return Object.keys(j).find(function (a) {
    var b = j[a]; // loop through all the dev company projects (second level)

    return b.find(function (a) {
      var b = a.image,
          d = a.slug; // Set plan to the project image (project plan)
      // if we are looking for an specific project name
      // loop through all the projects

      if (a.image = b ? _objectSpread({}, b, {
        url: c(b.url)
      }) : null, a.masterplan_flyer = a.masterplan_flyer ? c(a.masterplan_flyer) : null, a.duediligence_flyer = a.duediligence_flyer ? c(a.duediligence_flyer) : null, a.design_guidelines_flyer = a.design_guidelines_flyer ? c(a.design_guidelines_flyer) : null, PROJECT_SLUG) {
        if (d === PROJECT_SLUG) return m(a), !0;
      } else return m(a);

      return !1;
    });
  }), a.projects = {
    list: function list() {
      return {
        data: l
      };
    },
    retrieve: function retrieve(a) {
      return l.find(sift({
        slug: a
      }));
    }
  }, {
    list: function list() {
      var b = a.projects.retrieve(PROJECT_SLUG) || {};
      return {
        assetpath: f,
        data: k,
        project: b
      };
    },
    retrieve: function retrieve(b) {
      var c = k.find(function (a) {
        return a.slug === b;
      }),
          d = a.projects.retrieve(c.project_slug) || {};
      return c.plan = d.image, c;
    }
  };
};
export default initNeighbourhoods;